import request from '@/utils/request'
// 下拉
export function requestType() {
    //
    return request({
        url: '/bussiness/web/getComplaintTypeSelect',
        method: 'get',
    })
}

// 查询投诉信息
export function searchInfo() {
    return request({
        url: '/bussiness/web/getComplaintInfo',
        method: 'get',
    })
}

// 保存投诉内容
export function complaintContent(obj) {
    const data = {
        complaintTypeId:obj.complaintTypeId,// 问题类型id
        content:obj.content// 内容
    }
    return request({
        url: '/bussiness/web/addComplaintInfo',
        method: 'post',
        data: data
    })
}



// WEBPACK FOOTER //
// ./src/api/complaint.js